import useApiFetch from '@/hooks/useApiFetch';
import candidatesServices from '@/services/candidates';
import { FetchApiIds } from '@/types';
import { AvgTimeByTechStackData } from '@/types/api';
import { getPercentageAcceptanceRejection } from '@/utils/chart';
import ChartAvgTimeByTechStackComponent from './ChartAvgTimeByTechStack.component';

const ChartAvgTimeByTechStack = (): JSX.Element => {
  const response = useApiFetch<AvgTimeByTechStackData[]>(
    FetchApiIds.GET_AVG_TIME_TO_ACCEPTANCE_OR_REJECTION_GROUPED_BY_TECH_STACK,
    candidatesServices.getAvgTimeToAcceptanceOrRejectionByTechStack
  );

  const data = response.data ?? [];

  const grouped = data.map((c) => {
    return [c.chart.trio, c.chart.partners];
  });
  const flat = grouped.flat();
  const biggestNumber = flat.length ? Math.max(...flat) : 0;
  const withPercentage = getPercentageAcceptanceRejection(data, biggestNumber);

  return (
    <ChartAvgTimeByTechStackComponent
      title="Average Time to Acceptance or Rejection by Tech Stack in Days"
      tooltipMessage="This chart displays the average number of days that both Trio and our partners take to accept or reject a candidate according to their Main Tech Stacks."
      data={withPercentage}
      isLoading={response.isLoading}
    />
  );
};

export default ChartAvgTimeByTechStack;
